<template>
  <va-card :title="$t('menu.works')">
    <div class="row">
      <div class="flex xs6 sm3">
        <va-date-picker
          :label="$t('tables.date')"
          v-model="date"
        />
      </div>

      <div class="flex xs6 sm3">
        <va-select
          v-model="selected_operation"
          :options='daily_operations'
          label="Operação"
          textBy="operation_name"
          keyBy="id"
          clearable="false"
          placeholder="Selecione a operação desejada"
        />
      </div>

      <div class="flex xs6 sm3">
        <va-button v-if="this.data.length > 0"
          medium
          inline
          color="green"
          icon="fa fa-download"
          class="ma-0"
          @click="exportWorkedListsReport()"
        >
          {{ $t('menu.export') }}
        </va-button>
      </div>
    </div>
    <div class="row row-equal">
      <div class="flex xs12">
        <div class="row">

          <div class="flex xs12 md2">
            <va-card class="mb-4" color='secondary'>
              <p class="display-2 mb-0" :style="`color: ${$themes.primary}`">{{ pallets_mounted }}</p>
              <p :style="`color: ${$themes.primary}`"> PALLETS MONTADOS </p>
            </va-card>
          </div>

          <div class="flex xs12 md2">
            <va-card class="mb-4" color='secondary'>
              <p class="display-2 mb-0" :style="`color: ${$themes.primary}`">{{ pallets_mixed_mounted }}</p>
              <p :style="`color: ${$themes.primary}`"> MISTO </p>
            </va-card>
          </div>

          <div class="flex xs12 md2">
            <va-card class="mb-4" color='secondary'>
              <p class="display-2 mb-0" :style="`color: ${$themes.primary}`">{{ pallets_complete_mounted }}</p>
              <p :style="`color: ${$themes.primary}`"> COMPLETO </p>
            </va-card>
          </div>

          <div class="flex xs12 md2">
            <va-card class="mb-4" color='secondary'>
              <p class="display-2 mb-0" :style="`color: ${$themes.primary}`">{{ pallets_lp_integral_mounted }}</p>
              <p :style="`color: ${$themes.primary}`"> LP INTEGRAL </p>
            </va-card>
          </div>

          <div class="flex xs12 md2">
            <va-card class="mb-4" color='secondary'>
              <p class="display-2 mb-0" :style="`color: ${$themes.primary}`">{{ pallets_lp_double_mounted }}</p>
              <p :style="`color: ${$themes.primary}`"> LP DUPLO </p>
            </va-card>
          </div>

          <div class="flex xs12 md2">
            <va-card class="mb-4" color='secondary'>
              <p class="display-2 mb-0" :style="`color: ${$themes.primary}`">{{ pallets_container_mounted }}</p>
              <p :style="`color: ${$themes.primary}`"> CONTAINER </p>
            </va-card>
          </div>

          <div class="flex xs12 md2">
            <va-card class="mb-4" color='secondary'>
              <p class="display-2 mb-0" :style="`color: ${$themes.primary}`">{{ pallets_gaveta_mounted }}</p>
              <p :style="`color: ${$themes.primary}`"> GAVETA </p>
            </va-card>
          </div>
        </div>
      </div>
    </div>


    <va-data-table
      :fields="fields"
      :data="data"
      :per-page="15"
      :loading="loading"
    >
    </va-data-table>
  </va-card>
</template>

<script>

import { mapState } from "vuex";
import { showError } from '@/global';
import DailyOperationAPI from '@/services/DailyOperationAPI'

export default {
  name: 'modals',
  data () {
    return {
      data: [],
      loading: false,
      date: '',
      dateSelected: '',
      daily_operations: [],
      selected_operation: '',
      pallets_mixed_mounted: '',
      pallets_complete_mounted: '',
      pallets_lp_integral_mounted: '',
      pallets_lp_double_mounted: '',
      pallets_container_mounted: '',
      pallets_gaveta_mounted: '',
      pallets_mounted: '',
      filepath: '',
    }
  },
  async mounted () {
    const yesterday = new Date()

    yesterday.setDate(yesterday.getDate() - 1)

    this.date = yesterday

    this.getDailyOperations(yesterday, this.currentLocality.id)
  },

  methods: {
    async getDailyOperations(date, localityID) {
      this.loading = true

      DailyOperationAPI.getDailyOperations(date, localityID).then(response => {
        this.daily_operations = response.data.daily_operations

        if (this.daily_operations.length > 0 ){
          this.selected_operation = this.daily_operations[0]
        } else {
          this.data = []
          this.selected_operation = ''
        }

        this.loading = false
       }).catch(e => {showError(e); this.loading = false })
    },

    async getDailyOperationsWorked(operation) {
      this.loading = true

      DailyOperationAPI.getDailyOperationsWorked(operation.id).then(response => {
        this.data = response.data.worked_lists
        this.pallets_mixed_mounted = response.data.operation_resume['pallets_mixed_mounted']
        this.pallets_complete_mounted = response.data.operation_resume['pallets_complete_mounted']
        this.pallets_lp_integral_mounted = response.data.operation_resume['pallets_lp_integral_mounted']
        this.pallets_lp_double_mounted = response.data.operation_resume['pallets_lp_double_mounted']
        this.pallets_container_mounted = response.data.operation_resume['pallets_container_mounted']
        this.pallets_gaveta_mounted = response.data.operation_resume['pallets_gaveta_mounted']
        this.pallets_mounted = response.data.operation_resume['pallets_mounted']

        this.loading = false
      }).catch(e => {showError(e); this.loading = false })
    },
    exportWorkedListsReport () {
      let params = {
        daily_operation_id: this.selected_operation.id,
      }
      DailyOperationAPI.exportWorkedListsReport(params).then(response => {
        let url = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '')
        let link = document.createElement('a')
        this.filepath = url + response.data.filename
        document.body.appendChild(link)
        link.href = this.filepath
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        link.click()
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },
  },

  watch: {
    date: function(newDate, oldDate) {
      this.getDailyOperations(newDate, this.currentLocality.id)
    },

    selected_operation: function(operation){
      if (operation != ''){
        this.getDailyOperationsWorked(operation)
      } else {
        this.pallets_mixed_mounted = 0
        this.pallets_complete_mounted = 0
        this.pallets_lp_integral_mounted = 0
        this.pallets_lp_double_mounted = 0
        this.pallets_container_mounted = 0
        this.pallets_gaveta_mounted = 0
        this.pallets_mounted = 0
      }
    },

    '$store.state.currentLocality': function() {
      this.getDailyOperations(this.date, this.currentLocality.id)
    }
  },
  computed: {

    ...mapState(['currentLocality', 'currentUser']),

    fields () {
      return [{
        name: 'position',
        title: this.$t('tables.works.position'),
      },
      {
        name: 'user_name',
        title: this.$t('tables.orders.mounter'),
      },
      {
        name: 'login',
        title: this.$t('tables.orders.login'),
      },
      {
        name: 'boxes_mounted',
        title: this.$t('tables.works.quantity_total_boxes'),
      },
      {
        name: 'box_hour',
        title: this.$t('tables.works.box/hour'),
      },
      {
        name: 'errors',
        title: this.$t('tables.works.quantity_errors'),
      },
      {
        name: 'orders_mounted',
        title: this.$t('tables.works.quantity_total_orders'),
      },
      {
        name: 'pallets_mixed_mounted',
        title: this.$t('tables.works.mixed'),
      },
      {
        name: 'pallets_lp_double_mounted',
        title: this.$t('tables.works.lp_double'),
      },
      {
        name: 'pallets_container_mounted',
        title: 'CONTAINER',
      },
      {
        name: 'pallets_gaveta_mounted',
        title: this.$t('tables.works.locker'),
      }
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.auto-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  justify-content: space-around;
}
</style>
